const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/lists/collection.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/lists/collection")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});